import { createAsyncThunk } from "@reduxjs/toolkit";
import { customerPortal } from "@vilocnv/allsetra-core";
import { patchGeozone } from "../../api/patch-geozone";

type PatchGeozoneRequestDto = customerPortal.geozones.PatchGeozoneRequestDto;

const patchGeozoneAction = createAsyncThunk(
  "geozones/patchGeozoneAction",
  async (payload: PatchGeozoneRequestDto, thunkAPI) => {
    try {
      return await patchGeozone(payload);
    } catch (error: any) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export default patchGeozoneAction;
